import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0f172a',
      light: '#334155',
      dark: '#020617',
      contrastText: '#fff',
    },
    secondary: {
      main: '#0d9488',
      light: '#14b8a6',
      dark: '#0f766e',
      contrastText: '#fff',
    },
    background: {
      default: '#f8f8f6',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a1a1a',
      secondary: '#78716c',
    },
    success: { main: '#059669' },
    error: { main: '#dc2626' },
    warning: { main: '#d97706' },
    info: { main: '#0284c7' },
    divider: 'rgba(0,0,0,0.06)',
  },
  typography: {
    fontFamily: '"IBM Plex Sans", "Plus Jakarta Sans", sans-serif',
    h4: {
      fontWeight: 800,
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      letterSpacing: '-0.02em',
    },
    h5: {
      fontWeight: 700,
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      letterSpacing: '-0.01em',
    },
    h6: {
      fontWeight: 600,
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      letterSpacing: '-0.01em',
    },
    subtitle1: {
      fontWeight: 600,
      fontFamily: '"Plus Jakarta Sans", sans-serif',
    },
    subtitle2: {
      fontWeight: 600,
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontSize: '0.8rem',
    },
    body1: {
      fontSize: '0.9rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.825rem',
      lineHeight: 1.5,
    },
    caption: {
      fontSize: '0.7rem',
      letterSpacing: '0.01em',
    },
    overline: {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontWeight: 700,
      letterSpacing: '0.08em',
      fontSize: '0.625rem',
    },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          border: '1px solid rgba(0,0,0,0.06)',
          boxShadow: 'none',
          transition: 'border-color 0.2s ease',
          '&:hover': {
            borderColor: 'rgba(0,0,0,0.12)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none' as const,
          fontWeight: 600,
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          borderRadius: 8,
          minHeight: 40,
          fontSize: '0.8rem',
          letterSpacing: '0.01em',
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
        containedPrimary: {
          backgroundColor: '#0f172a',
          '&:hover': { backgroundColor: '#1e293b' },
        },
        containedSecondary: {
          backgroundColor: '#0d9488',
          '&:hover': { backgroundColor: '#0f766e' },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { minWidth: 40, minHeight: 40 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontSize: '0.725rem',
          height: 24,
          borderRadius: 6,
        },
        outlined: {
          borderColor: 'rgba(0,0,0,0.12)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid rgba(0,0,0,0.04)',
          padding: '12px 16px',
          fontSize: '0.8rem',
        },
        head: {
          fontWeight: 600,
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontSize: '0.7rem',
          textTransform: 'uppercase' as const,
          letterSpacing: '0.06em',
          color: '#78716c',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.015)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: '1px solid rgba(0,0,0,0.06)',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(0,0,0,0.05)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  },
});

export default theme;
